'use strict'

import ApiClient from './ApiClient'

export default class FileRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 名刺人物の名刺画像を取得します。
   * @param {object} options
   *      - {string} options.params.thumbnail サムネイル表示フラグ
   * @param {string} id 画像ID
   * @returns {*}
   */
  getBimage (options, id) {
    return ApiClient().get(`/files/bimage/${id}`, options)
  }

  /**
   * ユーザーの名刺画像を取得します。
   * @param {object} options
   *      - {string} options.params.thumbnail サムネイル表示フラグ
   * @param {string} id 画像ID
   * @returns {*}
   */
  getUimage (options, id) {
    return ApiClient().get(`/files/uimage/${id}`, options)
  }

  // V2で未使用
  // /**
  //  * 添付ファイルを取得します。
  //  * @param {object} options
  //  * @param {string} id ファイルID
  //  * @param {bool} isMgmt 管理モードフラグ
  //  * @returns {*}
  //  */
  // getAttach (options, id, isMgmt) {
  //   options = options || {}
  //   options.params = this.setMgmtParam(isMgmt)
  //   return ApiClient().get(`/files/attach/${id}`, options)
  // }

  /**
   * ファイルを取得します。
   * @param {object} options
   * @param {string} url
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  getFileByUrl (options, url, isMgmt) {
    options = options || {}
    options.params = this.setMgmtParam(isMgmt)
    return ApiClient().get(url, options)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/FileRepository.js